export const EXTRA_CONDITION = {
  unused: 'Unused',
  partsOnly: 'Parts Only',
  inoperable: 'Inoperable',
  glidered: 'Glidered'
};
